export default "__VITE_ASSET__0374dc87__"